const pagePath = "/applications/:id";
export default pagePath;
